import { DateTime } from "luxon";
import hmacSHA512 from 'crypto-js/hmac-sha512';

/**
 * Returns the credentials required for HMAC authentication
 */
export const getHmacCredentials = ({
	requestMethod,
	requestURI,
	turnstileToken
}) => {
    const requestTimeStamp = DateTime.now().toISO();
    const signatureRawData = requestMethod + requestTimeStamp + requestURI;

    const byteArray = new Uint8Array(JSON.parse(process.env.HMAC_AUTHENTICATOR_SECRET_ENCODED));
    const secret = byteArrayToString(byteArray);

    const signature = hmacSHA512(signatureRawData, secret);
    const authToken = `dc-api ${turnstileToken}:${signature}`;

    return {
        token: authToken,
        date: requestTimeStamp,
    };
};

export const byteArrayToString = (byteArray) => {
	return new TextDecoder().decode(byteArray);
};
